import React, { useEffect, useState } from 'react';
import VenueLogo from './VenueLogo';
import { Image as ImageIcon } from 'lucide-react';
export default function VenuePhoto({ venue }) {
  const source = venue.images?.[0];
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [source]);
  return <div className="relative h-full w-full">{source && !failed
    ? <img src={source} onError={() => setFailed(true)} alt={venue.name} loading="lazy" decoding="async" />
    : <div className="venue-photo-empty"><ImageIcon size={32} strokeWidth={1.3} aria-hidden="true" /><span>Fotoğraf henüz eklenmedi</span></div>}
    {(venue.logo_url || venue.featured) && <span className="absolute bottom-3 left-3"><VenueLogo venue={venue} /></span>}
  </div>;
}
